export const apiUrl = process.env.REACT_APP_API_URL;
export const defaultAvatarUrl =
  "http://res.cloudinary.com/artsu-me/image/upload/v1638716068/urx8b1kby9ig8v6wga6o.png";
export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const facebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID;
